import React from 'react';
import { Container } from 'react-bootstrap'
import { connect } from 'react-redux'
import CompetitorList from './components/event/CompetitorList';
import Selector from './layout/Selector';
import { selectItem} from './actions/eventActions';
// import { nextSelector, prevSelector , selectItem} from './actions/eventActions';
import { nextIdInSelectorList, prevIdInSelectorList} from './util/competitorUtil';
import { initUi, showSelection } from './actions/uiActions';
import { selectCompetitor } from './actions/eventActions';
import { getEvents, getLastTimeStamps } from './actions/eventActions';
import { sortCheckPointList} from './util/checkpointUtil';
import { competitorsForCurrentSelection, currentEventClass, currentTrack, currentEvent, eventClassesForCurrentTrack} from './selectors/currentItemsAndLists';

class  MainArea extends React.Component{

    sortNames(a,b){
        if( a.name > b.name) {
            return 1
        }
        else {
            return -1
        }
        
    }

    prepCheckPoints( checkPoints){
        let cpList = JSON.parse(JSON.stringify(checkPoints))

        const start = { name: 'Start', checkPoint: {postCode: 0 }, sequence: 0}
        const finish = { name: 'Mål', checkPoint: {postCode: 9999 }, sequence: 9999}
        cpList.push( start)
        cpList.push( finish)
        return sortCheckPointList( cpList)
    }
    prepEventClasses( eventClasses){
        let list = JSON.parse(JSON.stringify(eventClasses))
        const alle = { id: 0 , name: 'Alle'}
        list.push( alle)
        return list.sort( (a,b) => this.sortNames(a,b))
    }
    
    componentDidMount(){
        this.props.initUi()
        this.props.getEvents()
        this.timer = setInterval(() => this.props.getLastTimeStamps(), 5*1000);
      }

    componentWillUnmount() {
        clearInterval(this.timer);
        this.timer = null;
    }

    componentDidUpdate(){
        if( this.props.updateEvents === true){
            this.props.getEvents()
        }
    }

    render() {
        const trackVariant = this.props.currentTrack ? this.props.currentTrack.trackVariants[0] : null
        const { ui, currTrackID, currEventClassID, currCompetitorID, event, eventClasses } = this.props
        return (
            <React.Fragment>
                <Container fluid>
                    <div><Selector 
                        id={this.props.currTrackID} 
                        defaultText="Løype" 
                        type='track' 
                        list={event && event.tracks.sort( (a,b) => this.sortNames(a,b))}
                        nextIdInSelectorList={nextIdInSelectorList} 
                        prevIdInSelectorList={prevIdInSelectorList}
                        showSelection={this.props.showSelection}
                        selectItem={this.props.selectItem}
                        shouldShowSelection={ui.activeSelector === 'track'}

                        />
                    </div>
                    <div>
                        <Selector id={this.props.currEventClassID } 
                        defaultText="Klasse"
                        type='eventClass' 
                        list={event && eventClasses ? this.prepEventClasses(eventClasses) : null}
                        addToList={{'Alle':0}}
                        nextIdInSelectorList={nextIdInSelectorList} 
                        prevIdInSelectorList={prevIdInSelectorList}
                        showSelection={this.props.showSelection}
                        selectItem={this.props.selectItem}
                        shouldShowSelection={ui.activeSelector === 'eventClass'}
                        />
                    </div>
                    <div><Selector 
                        id={this.props.currCheckPointID} 
                        defaultText="Sted"  
                        type='checkPoint' 
                        list={trackVariant ? this.prepCheckPoints( trackVariant.controls): null }
                        nextIdInSelectorList={nextIdInSelectorList} 
                        prevIdInSelectorList={prevIdInSelectorList}
                        showSelection={this.props.showSelection}
                        selectItem={this.props.selectItem}
                        shouldShowSelection={ui.activeSelector === 'checkPoint'}
                        />
                    </div>
                    <div>
                        { (currEventClassID || currTrackID) && !currCompetitorID? 
                            <CompetitorList selectCompetitor={this.props.selectCompetitor}
                                            event={event} 
                                            track={this.props.currentTrack}
                                            competitors= {this.props.competitors}/>
                            : null}
                    </div>
                </Container>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => ({
    ui: state.ui
    , currEventID: state.events.currEventID
    , currTrackID: state.events.currTrackID
    , currEventClassID: state.events.currEventClassID
    , currCompetitorID: state.events.currCompetitorID
    , currClubID: state.events.currClubID
    , currCheckPointID: state.events.currCheckPointID
    , events: state.events.events
    , updateEvents: state.events.updateEvents
    , event: currentEvent(state)
    , eventClasses: eventClassesForCurrentTrack( state)
    , competitors: competitorsForCurrentSelection( state)
    , currentTrack: currentTrack( state)
    , currentEventClass: currentEventClass( state)
})

export default connect( mapStateToProps, { initUi, getEvents, selectCompetitor, showSelection, selectItem, getLastTimeStamps} )(MainArea);

